/* eslint-disable jsx-a11y/anchor-is-valid */

import { openPopupWidget } from "react-calendly"
import React, { CSSProperties } from 'react'

/*
const MEDIUM_ROOT = 'https://medium.com/@santiagoq'
const WHITEPAPER_TITLE = `what-am-i-looking-for-in-an-ai-powered-community-manager`
const WHITEPAPER_LINK = `${MEDIUM_ROOT}/${WHITEPAPER_TITLE}-b25b90fed2f`
*/

const authURL = 'https://api.twitter.com/oauth/authenticate?oauth_token'
interface iTwitterButton { oauthToken: string, style?: CSSProperties }
export const TwitterButton = ({ oauthToken, style={} }: iTwitterButton) => oauthToken 
    ?
        <a href={`${authURL}=${oauthToken}`} style={{ height: 28}} > 
            <img alt="Twitter Login Button" src={'./login-button.png'} style={style}/>
        </a>

    :   <img alt="Twitter Login Button" src={'./login-button.png'} style={{marginRight:12, marginLeft: 12, ...style}}/>


export const GumRoad = () => <a 
    style={{ marginTop:-4 }}
    className="gumroad-button" 
    href="https://gum.co/socialQ" 
    rel="noopener noreferrer"
    target="_blank"
>Buy with Gumroad</a>


export const Calendly = () => <a 
    className="button is-light" 
    style={{ height:28, paddingLeft:0}} 
    onClick={() => openPopupWidget({ url: 'https://calendly.com/SocialQ/30min' })}
> 
    <img src="calendly.png" alt="Calendly Link" style={{margin:10, height:20}}/>
    Calendly 
</a>
